
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const CoreValuesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Core Values - HP Inc Consulting Services | Safety Excellence Principles"
        description="Discover the core values that drive HP Inc Consulting Services commitment to workplace safety excellence, OSHA compliance, and professional safety consulting services."
        keywords="safety consulting values, workplace safety principles, OSHA compliance values, professional safety ethics, safety company culture, workplace safety commitment"
        canonical="https://hpincconsultant.com/core-values"
        ogTitle="Core Values - HP Inc Consulting Services"
        ogDescription="Learn about the core values and principles that guide our commitment to workplace safety excellence and professional consulting services."
        ogUrl="https://hpincconsultant.com/core-values"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Our Core Values
              </h1>
              <p className="text-xl mb-8">
                The principles that guide everything we do
              </p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-semibold mb-4">Safety First</h3>
                  <p className="text-gray-600">We prioritize the safety and well-being of all workers above everything else.</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-award-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-semibold mb-4">Excellence</h3>
                  <p className="text-gray-600">We strive for excellence in every project and service we deliver.</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-handshake-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-semibold mb-4">Integrity</h3>
                  <p className="text-gray-600">We conduct business with honesty, transparency, and ethical practices.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CoreValuesPage;
